import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import FoodMenu from '../components/food_menu';
import { pageAction } from '../redux_files/actions/page_actions';

const OurFoodMenu = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = 'Our Food Menu';
    dispatch(pageAction('Our Food Menu'));
  }, [document.title]);

  return (
    <div className='container'>
      <div className="text-center auto-margin">*<b>Catering and Tiffin Services</b> available at affordable prices.</div>
      <FoodMenu />
    </div>
  );
};

export default OurFoodMenu;
